/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfstring
 */
export interface ApiResultOfstring {
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfstring
     */
    data?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfstring
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfstring
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfstring
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfstring
     */
    result?: ApiResultOfstringResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfstringResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfstringFromJSON(json: any): ApiResultOfstring {
    return ApiResultOfstringFromJSONTyped(json, false);
}

export function ApiResultOfstringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfstring {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfstringToJSON(value?: ApiResultOfstring | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

